module.exports = __webpack_public_path__ + "static/media/marketoProcess3.aa90788b.png";